import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { frameSettings } from "shared/utils/doorConfigurations";

interface FrameProps extends frameSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const Frame: React.FC<FrameProps> = ({
  doorNodes,
  materials,
  index,
  ...frameSettings
}: FrameProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height);
  const scaling = getFrameScaling(width, height);

  return (
    <group dispose={null} scale-x={frameSettings?.generalScaleX ?? 1}>
      <mesh
        geometry={doorNodes["frame_bottom"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={positions.bottom}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_left"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.vertical.x + (frameSettings?.frameLeft?.scaleX ?? 0),
          scaling.vertical.y + (frameSettings?.frameLeft?.scaleY ?? 0),
          scaling.vertical.z,
        ]}
        position={[
          positions.left.x + (frameSettings?.frameLeft?.shiftX ?? 0),
          positions.left.y,
          positions.left.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_right"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.vertical.x + (frameSettings?.frameRight?.scaleX ?? 0),
          scaling.vertical.y + (frameSettings?.frameRight?.scaleY ?? 0),
          scaling.vertical.z,
        ]}
        position={[
          positions.right.x + (frameSettings?.frameRight?.shiftX ?? 0),
          positions.right.y,
          positions.right.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_top"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.horizontal.x,
          frameSettings?.frameTop?.scaleY ?? scaling.horizontal.y,
          scaling.horizontal.z,
        ]}
        position={[
          positions.top.x,
          positions.top.y + (frameSettings?.frameTop?.shiftY ?? 0),
          0,
        ]}
      ></mesh>
    </group>
  );
};

export default Frame;
